
export function sendMessage (messageObject, message) {
    const sendMessage = message || 'tealium_pym_event';

    console.log('Send Message:', sendMessage);
    console.log(JSON.stringify(messageObject));

    try {
        window.pymChild.sendMessage(
            sendMessage,
            JSON.stringify(messageObject),
        );
    }
    catch (e) {
        console.log('sendMessage error:', e);
    }

}

export function scrollToPosition (position) {
    const scrollPosition = position || 0;

    try {
        window.pymChild.scrollParentToChildPos(scrollPosition);
    }
    catch (e) {
        console.log('scrollToPosition error:', e);
    }

}

export function scrollToElement (elementId) {

    if (elementId) {
        try {
            window.pymChild.scrollParentToChildEl(elementId);
        }
        catch (e) {
            console.log('scrollToElement error:', e);
        }
    }
    else {
        console.log('===============================================================');
        console.log('I think you forgot something... the element ID to scroll to...?');
        console.log('===============================================================');
    }

}

export function scrollToAnchorPosition (element) {
    setTimeout(()=>{
        // Adjustment for global nav bar
        if (!document.querySelector(element)) {
            console.log(`${element} does not exist: ${document.querySelector(element)}`);
            return;
        }
        const position = document.querySelector(element).offsetTop - 40;
        console.log('position:', position);

        document.body.scrollTop = position;
        document.documentElement.scrollTop = position;
        if (window.self !== window.top) {
            scrollToPosition(position);
        }
    }, 250);
}
